import BlockDiagram from '@/views/BlockDiagram'

function PlaygroundPage() {
  return (
    <section className="playground-workspace">
      <BlockDiagram />
    </section>
  )
}

export default PlaygroundPage
